export const CHECKOUT_TOKEN = "checkoutToken";
export const API_URI = process.env.NEXT_PUBLIC_API_URI || "";
export const DEFAULT_CHANNEL = process.env.NEXT_PUBLIC_DEFAULT_CHANNEL || "";
export const CUSTOMIZATION_KEY = "customizationForm";

export const STRIPE_GATEWAY = "saleor.payments.stripe";
